<template>
  <div :class="$isFlag?'registerH5 accountCommonH5':'registerWeb accountCommonWeb'">
    <header-item
      :title-array="titleArray"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <div class="formClass">
      <!-- 注册 -->
      <div>
        <van-form class="findTwo" @submit="onSubmitReg">
          <van-field
            v-model="formParams.username"
            style="border-radius: 16px"
            label="注册手机号："
            :rules="rules.mobileRules"
          />
          <p class="reg_p" style="">
            *该手机号为雷霆账号，雷霆账号一旦注册成功就无法变更。
          </p>

          <van-field
            v-model="formParams.code"
            style="border-radius:16px"
            maxlength="6"
            label="短信验证码："
            :rules="rules.codeRules"
          >
            <template #button>
              <p
                v-if="!showTime"
                style="color: #616edf; cursor: pointer"
                @click="getCode"
              >
                {{ timeMsg }}
              </p>
              <p v-else style="color: #878787; cursor: pointer">
                {{ codeTime }} S
              </p>
            </template>
          </van-field>
          <p class="reg_p" style="">*如果一分钟内没有收到验证码请重新获取</p>
          <van-field
            v-model="formParams.password"
            style="border-radius: 16px 16px 0 0"
            label="新密码："
            type="password"
            :rules="rules.passwordRules"
          />
          <van-field
            v-model="formParams.secondPassword"
            label="确认新密码："
            type="password"
            :rules="rules.passwordRules"
          />
          <van-field
            v-model="formParams.realName"
            label="真实姓名："
            :rules="rules.nameRules"
          />
          <van-field
            v-model="formParams.idCard"
            style="border-radius: 0 0 16px 16px"
            label="身份证号："
            :rules="rules.idRules"
          />
          <p class="reg_p--red">*未满18周岁的用户不允许注册雷霆账号</p>
          <div class="bottom">
            <van-checkbox
              v-model="checked"
              class="checkbox"
            >我已阅读并同意
              <span
                style="color: #626fdd"
                @click.stop="ltPassRule"
              >《雷霆游戏用户协议》</span>
              <span
                style="color: #626fdd"
                @click.stop="ltUserRule"
              >《雷霆游戏用户隐私政策》</span>
            </van-checkbox>
            <van-button
              round
              block
              type="info"
              native-type="submit"
              color="#616edf"
              class="formClass_btn"
            >注册</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import { ltCaptcha } from '@/utils/ltCaptcha'
import sendCode from '@/mixins/sendCode'
import * as api from '@/api/login'
import rules from '@/mixins/validator'

export default {
  name: 'Register',
  components: {
    headerItem
  },
  mixins: [sendCode],
  data() {
    return {
      username: '',
      rules: rules,
      formParams: { username: '' },
      checked: false,
      ltCaptcha: null,
      titleArray: ['账号注册', '首页', '账号管理中心', '账号注册']
    }
  },
  created() {},
  mounted() {},
  methods: {
    getCode() {
      if (!this.formParams.username) {
        this.$msg('请输入手机号')
        return
      }
      if (!this.$tool.isValidPhone(this.formParams.username)) {
        this.$msg('请输入正确的手机号')
        return
      }
      ltCaptcha((captcha) => {
        this.$tool.sendCode({
          type: 'REGISTER',
          phone: this.formParams.username,
          captcha
        }).then((res) => {
          if (res.status == 0) {
            this.startTimer()
            this.$msg('短信发送成功', 'success')
          }
        })
      })
    },
    navBarClick() {
      this.$router.push('/accountCenter/index')
    },
    ltPassRule() {
      window.open('https://www.leiting.com/terrace/news/news_detail_ff8080816778e02401677c1119d30006.html')
    },
    ltUserRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff80808171a5bad00171a64e53870006.html'
      )
    },
    onSubmitReg() {
      if (!this.checked) {
        this.$msg('请先勾选并同意')
        return
      }
      if (this.formParams.secondPassword != this.formParams.password) {
        this.$msg('两次输入的密码不一致')
        return
      }
      // const params = { ...this.formParams }
      api
        .common_aes({ ...this.formParams, phone: this.formParams.username })
        .then((res) => {
          if (res.status == 0) {
            this.$msg(res.message, 'success')
            this.formParams = {}
          }
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>
// h5
.registerH5 {
  font-size: 0.25rem;
  border-radius: 10px;
  background: #fff;

  .checkbox {
    margin: 0.3rem 0;
    font-size: 0.28rem;
    position: relative;

    ::v-deep .van-checkbox__icon {
      margin-right: 0.2rem;
    }
  }

  #ltCaptchaLogin {
    margin: 0.5rem 0;
    display: flex;
    justify-content: center;
  }

  #ltCaptchaLogin #SM_BTN_1, #ltCaptchaLogin #sm-btn-bg {
    width: 100% !important;
    height: 0.86rem !important;
    line-height: 0.86rem !important;
  }

  .formClass {
    padding: 2% 5%;
    margin: 0 auto 1rem;
    background: #f5f7fb;

    .login {
      width: 90%;
      margin: auto;

      .imgclass {
        width: 50%;
        display: block;
        margin: 0.3rem auto;
      }
    }

    .sub_title {
      font-size: 0.5rem;
      font-weight: bold;
      text-align: center;
      margin: 0.5rem 0;
    }

    .sub_bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 1.5rem;
      color: #C3BED4;
      font-size: 0.34rem;
    }

    .submit {
      ::v-deep .van-cell {
        align-items: center;
        border: 1px solid #ccc;
        padding: 0.1rem 0.2rem;
      }

      img {
        height: 0.48rem;
        vertical-align: middle;
      }
    }
  }

  .findTwo {
    margin: 0.5rem 0;

    ::v-deep .van-cell {
      // margin: .2rem 0;
      font-size: 0.28rem;
    }

    .formClass_btn {
      margin: 0.3rem 0;
    }

    .reg_p {
      padding: 0.3rem;
      color: #878787;
    }

    .reg_p--red {
      padding: 0.3rem;
      color: #ee0a24;
    }

    .bottom {
      margin: 0 0.2rem;

      p {
        margin: 0.2rem;
      }
    }
  }
}

// }
// web
  .registerWeb {
    font-size: 0.25rem;
    border-radius: 10px;
    background: #fff;
    margin-left: 0.2rem;
    margin: 3% 10%;
    font-size: 0.25rem;

    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
    }

    .formClass {
      padding: 1% 0 2%;
      width: 41%;
      margin: 0 auto 1rem;

      .sub_title {
        font-size: 0.5rem;
        font-weight: bold;
        text-align: center;
        margin: 0.5rem 0;
      }

      .sub_bottom {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 1.5rem;
        color: #C3BED4;
        font-size: 0.34rem;
      }

      .submit {
        ::v-deep .van-cell {
          align-items: center;
          border: 1px solid #ccc;
          padding: 0.1rem 0.2rem;
        }

        ::v-deep .van-field__body {
          border: none;
        }

        img {
          height: 0.48rem;
          vertical-align: middle;
        }
      }
    }

    .findTwo {
      ::v-deep .van-cell {
        font-size: 0.28rem;
      }

      .reg_p {
        padding-left: 0.4rem;
        color: #878787;
      }

      .reg_p--red {
        padding: 0 0.3rem 0.3rem;
        color: #ee0a24;
      }

      .formClass_btn {
        margin: 0.3rem 0;
      }

      .bottom {
        p {
          margin: 0.2rem;
        }
      }
    }
  }
// }
</style>
